import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/ispace/client-v2/src/app/register/components/RegisterScreen.tsx");
